import { environment } from "./env";

const demoConfig = {
  domain: "demo-wolfepak.us.auth0.com",
  clientId: "sCzgxBRyn37wPmQlvBUmmkwVZOwfFarI",
  audience: "https://pakenergy.com/api",
};

const devConfig = {
  domain: "dev-wolfepak.us.auth0.com",
  clientId: "d53GB7w2ELDF02ZeJJbFNIRYRdfV3juV",
  audience: "https://pakenergy.com/api",
};

const prodConfig = {
  domain: "prod-wolfepak.us.auth0.com",
  clientId: "ILb2wbKlGFqKYJZwMTzYolM4D65A1wWp",
  audience: "https://pakenergy.com/api",
};

const qaConfig = {
  domain: "qa-wolfepak.us.auth0.com",
  clientId: "KQQj38Xmf51Lrny1Onrkb1PB9dK3DxOW",
  audience: "https://pakenergy.com/api",
};

const preConfig = {
  domain: "pre-wolfepak.us.auth0.com",
  clientId: "ol247PihJie4RITASqWgReAp2NPNF8ug",
  audience: "https://pakenergy.com/api",
};

const uatConfig = {
  domain: "uat-wolfepak.us.auth0.com",
  clientId: "oaSWc98eQeQPjnwnlscujPO5pgRX239W",
  audience: "https://pakenergy.com/api",
};

const config = {
  demo: demoConfig,
  dev: devConfig,
  qa: qaConfig,
  uat: uatConfig,
  pre: preConfig,
  prod: prodConfig,
};

let currentConfig = config[environment];

export default {
  audience: currentConfig.audience,
  clientId: currentConfig.clientId,
  domain: currentConfig.domain,
};
